import React from "react";
import { useNavigate } from "react-router-dom";
import Paths from "../../router/Paths";
import { useSelector } from "react-redux";

function HomeHeroSection() {
  const reward = useSelector((state) => state.user?.reward);
  const navigate = useNavigate();
  return (
    <section className="w-full flex flex-col items-center px-4 text-center py-12">
      {/* Title */}
      <h1 className="text-3xl font-extrabold leading-tight md:text-4xl">
        Launch Your Online <br />
        Travel Business in Days
      </h1>

      {/* Subtitle */}
      <p className="mt-4 text-gray-500 text-base md:text-lg">
        Flights • Hotels • Tours • Insurance
      </p>
      <p className="mt-1 font-semibold text-black text-base md:text-lg">
        All in One Platform
      </p>

      {/* Buttons */}
      <div className="mt-8 w-full flex flex-col gap-3">
        <a
          href="https://www.intraverse.africa/"
          rel="noreferrer"
          target="_blank"
        >
          <button className="w-full rounded-lg bg-primary1 text-white font-medium py-3 hover:opacity-90 transition">
            Learn more
          </button>
        </a>
        <button
          className="w-full rounded-lg bg-black text-white font-medium py-3 hover:opacity-90 transition"
          onClick={() => {
            navigate(reward?._id ? Paths.congra : Paths.spin);
          }}
        >
          {reward?._id ? "Claim reward" : "Spin & Win"}
        </button>
      </div>
    </section>
  );
}

export default HomeHeroSection;
